import {observer} from "mobx-react-lite";
import React from "react";
import {IconSource} from "../../../shared/enums/iconSource";
import {ObservableList} from "../../../stores/observables/observableList";
import {RadioGroupKeyValue} from "../../../stores/observables/radioGroupKeyValues/radioGroupKeyValue";
import Banner from "../../atoms/banner/banner";
import RadioGroup from "../../atoms/radioGroup/radioGroup";
import EditField from "../editField/editField";

export interface IRadioGroupEditProps {
  // The list of values the user can select from
  items: ObservableList<RadioGroupKeyValue>;

  // The name of the group, which must be unique per page
  name: string;

  // Is the component currently disabled
  isDisabled?: boolean;

  // Callback for when an item is selected
  onSelect?: (item: RadioGroupKeyValue) => void;

  // How the items will layout
  orientation?: "list" | "grid";

  // The label to show above the radio items
  label?: string;

  // The validation message to show when not valid
  validationMessage?: string;

  // Is this item marked as required
  isRequired?: boolean;

  // True if the text input is valid
  isValid?: boolean;

  // The banner text to show banner
  bannerText?: string;

  // The icon for banner
  bannerIcon?: IconSource;
}

const RadioGroupEdit: React.FC<IRadioGroupEditProps> = ({
  items,
  name,
  isDisabled = false,
  onSelect,
  orientation = "list",
  label,
  validationMessage,
  isRequired,
  isValid,
  bannerText,
  bannerIcon = IconSource.info
}: IRadioGroupEditProps) => {
  return (
    <EditField
      label={label}
      showValidationMessage={!isValid}
      validationMessage={validationMessage}
      validationMessagePosition="bottom"
      isRequired={isRequired}
    >
      <>
        {bannerText && <Banner text={bannerText} icon={bannerIcon} />}
        <RadioGroup
          items={items}
          name={name}
          isDisabled={isDisabled}
          onSelect={onSelect}
          orientation={orientation}
        />
      </>
    </EditField>
  );
};

export default observer(RadioGroupEdit);
